import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";
import axiosInstance from "../AxiosInstance";
import SidebarLayout from "../SidebarLayout";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import CreateArticle from "./CreateArticle";
import TurndownService from "turndown";
import "../../assets/styles/KBArticles.css";
import { Editor } from "@tinymce/tinymce-react";
import SearchBar from "./SearchBar";
import {jwtDecode} from 'jwt-decode';
import ContextMenu from "./ContextMenu";


const KBArticlesMain = () => {
  const { id } = useParams();
  const [content, setContent] = useState("");
  const [currentArticle, setCurrentArticle] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [isAddMode, setIsAddMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [kbarticleTitle, setKbarticleTitle] = useState();
  const [tagData, setTagData] = useState([]);
  const [originalTreeData, setOriginalTreeData] = useState([]);
  const token = localStorage.getItem("token"); 

  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, categoryId: null });
          let userRole = null;
          let icpisname=null;
          if (token) {
          const decodedToken = jwtDecode(token);
          userRole = decodedToken.claims.role;
          icpisname=decodedToken.claims.firstname;
        }

        const handleContextMenu = (event, categoryId) => {
          event.preventDefault();
          setContextMenu({
            visible: true,
            x: event.pageX,
            y: event.pageY,
            categoryId,
          });
        };
      
        const handleMenuAction = (action) => {
          switch (action) {
            case "add":
              handleAddCategory(contextMenu.categoryId);
              break;
            case "edit":
              handleEditCategory(contextMenu.categoryId);
              break;
            case "delete":
              handleDeleteCategory(contextMenu.categoryId);
              break;
            default:
              break;
          }
          setContextMenu({ visible: false, x: 0, y: 0, categoryId: null }); // 隐藏菜单
        };
        
        const handleAddCategory = (parentId) => {
          const categoryName = prompt("Enter the name for the new category:");
          if (categoryName) {
            const params = new URLSearchParams();
            params.append("name", categoryName);
            params.append("parentId", parentId);
        
            axiosInstance
              .post("/category", params, {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
              })
              .then(() => {
                
                alert("Category added successfully!");
                fetchTreeData(); // 刷新分类树
              })
              .catch((err) => console.error("Failed to add category", err));
          }
        };
        
      
        const handleEditCategory = (categoryId) => {
          const categoryName = prompt("Enter the new name for this category:");
          if (categoryName) {
            axiosInstance
              .put(`/category`, null, {
                params: {
                  name: categoryName, // 查询参数 `name`
                  id: categoryId,     // 查询参数 `id`
                },
              })
              .then(() => {
                alert("Category updated successfully!");
                fetchTreeData(); // 刷新分类树
              })
              .catch((err) => console.error("Failed to update category", err));
          }
        };
      
        const handleDeleteCategory = (categoryId) => {
          if (window.confirm("Are you sure you want to delete this category?")) {
            axiosInstance
              .delete('/category', {
                params: { categoryId }, // 将 categoryId 作为查询参数
              })
              .then(() => {
                alert("Category deleted successfully!");
                fetchTreeData(); // 刷新分类树
              })
              .catch((err) => console.error("Failed to delete category", err));
          }
        };
  const handleArticleClick = (articleId) => {
    console.log(userRole);
    if (isAddMode) {
      setIsAddMode(false);
    }
    axiosInstance
      .get(`/kbarticles/${articleId}`)
      .then((res) => {
        const turndownService = new TurndownService();
        const markdownContent = turndownService.turndown(res.data.content);
        setContent(markdownContent);
        setKbarticleTitle(res.data.title);
        setTagData(res.data.tags);
        setCurrentArticle(res.data);
        setIsEditMode(false);
      })
      .catch((err) => console.error("Failed to fetch article content", err));
  };
//search article
  const handleSearch = (query) => {
    if (!query.trim()) {
      setTreeData(originalTreeData); // 搜索框为空时恢复原始数据
      return;
    }

    const lowerCaseQuery = query.toLowerCase();

    const filterTreeData = (nodes) => {
      const filteredChildren = nodes.children?.map(filterTreeData).filter((child) => child) || [];
      const filteredArticles = nodes.articles?.filter((article) => {
        const titleMatch = article.title.toLowerCase().includes(lowerCaseQuery);
  
        // 检查 tags 数据结构
        const tagsMatch = Array.isArray(article.tags) && article.tags.some((tag) => {
          // 如果 tag 是字符串
          if (typeof tag === "string") {
            return tag.toLowerCase().includes(lowerCaseQuery);
          }
  
          // 如果 tag 是对象
          if (typeof tag === "object" && tag.name) {
            return tag.name.toLowerCase().includes(lowerCaseQuery);
          }
  
          return false; // 其他情况忽略
        });
  
        return titleMatch || tagsMatch;
      });
  
      if (filteredChildren.length > 0 || (filteredArticles && filteredArticles.length > 0)) {
        return {
          ...nodes,
          children: filteredChildren,
          articles: filteredArticles,
        };
      }
      return null;
    };
  
    const filteredTreeData = originalTreeData.map(filterTreeData).filter((node) => node);
    setTreeData(filteredTreeData);
  };
  const fetchTreeData = () => {
    axiosInstance
      .get("/category")
      .then((res) => {
        setTreeData(res.data);
        console.log("category",res.data);
        setOriginalTreeData(res.data);
      })
      .catch((err) => console.error("Failed to fetch KB tree", err));
  };

  useEffect(() => {
    fetchTreeData();

    const closeContextMenu = () => setContextMenu({ visible: false, x: 0, y: 0, categoryId: null });
    document.addEventListener("click", closeContextMenu);

    return () => {
      document.removeEventListener("click", closeContextMenu);
    };
  }, []);

  const handleDeleteArticle = () => {
    if (!currentArticle) return;
    if (window.confirm("Are you sure you want to delete this article?")) {
      axiosInstance
        .delete(`/kbarticles/${currentArticle.id}`)
        .then(() => {
          alert("Article deleted successfully!");
          setContent("");
          setCurrentArticle(null);
          fetchTreeData();
        })
        .catch((err) => console.error("Failed to delete article", err));
    }
  };

  const handleSaveEdit = () => {
    if (!currentArticle) return;
      // 提取 tags 的 name 字段
    const tags = currentArticle.tags?.map((tag) => tag.name) || [];
   
  const params = new URLSearchParams();
  params.append("title", currentArticle.title);
  params.append("content", content);
  tags.forEach((tag) => params.append("tags", tag)); // 多个 tags 参数

    axiosInstance
      .put(`/kbarticles/${currentArticle.id}`,null,{params})
      .then(() => {
        alert("Article updated successfully!");
        setIsEditMode(false);
        fetchTreeData();
      })
      .catch((err) => console.error("Failed to update article", err));
  };

  const renderTree = (nodes) => {
    if (!nodes) return null;
    
    return (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id.toString()}
        label={
          <div
          style={{ fontWeight: "bold", fontSize: "16px", position: "relative" }}
          onContextMenu={(e) => handleContextMenu(e, nodes.id)} // 确保绑定事件
        >{nodes.name}</div>
        }
      >
        {/* 渲染文章列表 */}
        {nodes.articles.length > 0 && (
          <ul style={{ marginLeft: "20px", padding: 0, listStyleType: "circle" }}>
            {nodes.articles.map((article) => (
              <li
                key={`article-${article.id}`}
                onClick={(e) => {
                  e.stopPropagation(); // 阻止事件冒泡到父级 TreeItem
                  handleArticleClick(article.id);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  margin: "5px 0",
                  color: "#007bff",
                  textDecoration: "underline",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0f0f0"; // 悬浮时背景色
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent"; // 离开时恢复背景色
                }}
              >
                {article.title}
              </li>
            ))}
          </ul>
        )}
  
        {/* 渲染子分类 */}
        {Array.isArray(nodes.children) &&
          nodes.children.map((child) => renderTree(child))}
      </TreeItem>
    );
  };

  return (
    <SidebarLayout>
      <div style={{ display: "flex", height: "100vh" }}>
        <div style={{ width: "20%", padding: "10px", overflowY: "auto", borderRight: "1px solid #ddd" }}>
          {/* <div style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
            <input
              type="text"
              placeholder="Search articles or tags..."
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ddd",
                width: "100%",
                }}
            />
          </div> */}
          <SearchBar onSearch={handleSearch}/>
          <TreeView
            defaultCollapseIcon={<ExpandLess />}
            defaultExpandIcon={<ExpandMore />}
            defaultExpanded={Array.isArray(treeData) ? treeData.map((node) => node.id.toString()) : []}
            sx={{ pl: 4 }}
          >
           {Array.isArray(treeData) ? treeData.map((node) => renderTree(node)) : null}
          </TreeView>
          <div style={{ marginTop: "20px", padding: "10px", borderTop: "1px solid #ddd", bottom: 0 }}>
          <h3 style={{ fontSize: "18px", marginBottom: "10px" }}>Need more help?</h3>
             <a
                href="https://stackoverflowteams.com/c/gosvea-inc/questions" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
                }}
                >
    Visit Stack Overflow for Gosvea
  </a>
</div>
        </div>

        <div style={{ width: "80%", padding: "10px", overflowY: "auto" }}>
          {userRole==="ROLE_ICPIE"&&(
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
            <button
              onClick={() => setIsAddMode(!isAddMode)}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
                marginLeft: "auto",
              }}
            >
              {isAddMode ? "Cancel" : "Add"}
            </button>
          </div>
          )}
          {isAddMode ? (
            <CreateArticle onArticleCreated={fetchTreeData} onCancel={() => setIsAddMode(false)} />
          ) : (
            <div>
              {isEditMode ? (
                <Editor
                  apiKey="p3lut8e5pnk7o8f3y37ianvo09hpm2ov6gkl1jfn6nx9j1e1"
                  initialValue={currentArticle.content}
                  value={content}
                  onEditorChange={(newContent) => setContent(newContent)}
                  init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                      "image",
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | image | formatselect | bold italic backcolor | " +
                      "alignleft aligncenter alignright alignjustify | " +
                      "bullist numlist outdent indent | removeformat | help",
                    //image_upload_url: "/s3/files",
                    paste_data_images: true,
                    automatic_uploads: true,
                    images_upload_handler: function (blobInfo, success, failure) {
                      const formData = new FormData();
                      formData.append("file", blobInfo.blob(), blobInfo.filename());
                      console.log("Uploading image to /s3/files...");
                      axiosInstance
                        .post("/s3/files", formData)
                        .then((response) => {
                          if (response.data && response.data.location) {
                            success(response.data.location); // 将返回的图片 URL 插入到编辑器中
                          } else {
                            failure("Invalid response format");
                          }
                        })
                        .catch((error) => {
                          failure("Image upload failed: " + error.message);
                        });
                    }
                  }}
                />
              ) : (
                <div>
                  {kbarticleTitle && (
                    <h1 style={{ fontSize: "24px", marginBottom: "20px", textAlign: "center" }}>
                      {kbarticleTitle}
                    </h1>
                  )}
                  <ReactMarkdown>{content}</ReactMarkdown>
                </div>
              )}

              {currentArticle && userRole === "ROLE_ICPIE"&& (
                <div
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "500px",
                    right: "0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 80px",
                  }}
                >
                  <button
                    onClick={() => setIsEditMode(!isEditMode)}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "100px",
                    }}
                  >
                    {isEditMode ? "Save" : "Edit"}
                  </button>
                  <button
                    onClick={isEditMode ? handleSaveEdit : handleDeleteArticle}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: isEditMode ? "green" : "red",
                      color: "#fff",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "100px",
                    }}
                  >
                    {isEditMode ? "Save Edit" : "Delete"}
                  </button>
                </div>
              )}
            </div>
          )}
          <div className="tag-cloud-container">
            <div className="tag-cloud">
              {tagData.map((tag) => (
                <span key={tag.id} className="tag">
                  {tag.name}
                </span>
              ))}
            </div>
          </div>
        </div>
        <ContextMenu x={contextMenu.x} y={contextMenu.y} visible={contextMenu.visible} onAction={handleMenuAction} />
        
      </div>
    </SidebarLayout>
  );
};

export default KBArticlesMain;
